import createAxios from "./axiosHttpMarconi";
export const geonameService = {
  getPaises,
  getAll,
  getById,
  updateById,
  deleteById,
  create,
  getProvinces,
};

function getPaises(filters) {
  const axios = createAxios();
  let urlPath = "/geonames/countries";
  if (filters && filters.tipo) {
    urlPath += `?tipo=${filters.tipo}`;
  }
  if (filters && filters.limit) {
    urlPath += `?limit=${filters.limit}`;
  }
  return axios.get(urlPath);
}

function getProvinces(filters) {
  const axios = createAxios();
  let urlPath = "/geonames/provinces";
  if (filters && filters.tipo) {
    urlPath += `?tipo=${filters.tipo}`;
  }
  if (filters && filters.limit) {
    urlPath += `?limit=${filters.limit}`;
  }
  return axios.get(urlPath);
}

function getAll(pagination, filters) {
  const axios = createAxios();
  let urlPath = `/geonames`;
  pagination = {
    page: pagination.currentPage - 1,
    limit: pagination.perPage,
  };
  const params = new URLSearchParams({ ...pagination, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function getById(geonameId) {
  const axios = createAxios();
  const urlPath = `/geonames/${geonameId}`;
  return axios.get(urlPath);
}

function updateById(geonameId, body) {
  const axios = createAxios();
  const urlPath = `/geonames/${geonameId}`;
  return axios.put(urlPath, body);
}

function deleteById(geonameId) {
  const axios = createAxios();
  const urlPath = `/geonames/${geonameId}`;
  return axios.delete(urlPath);
}

function create(data) {
  const axios = createAxios();
  const urlPath = `/geonames`;
  return axios.post(urlPath, data);
}
